export default __webpack_public_path__ + "static/media/bheegi-si-bhaagi-si.836ca075.jpg";